/**
 *
 */
const globalData: Record<string, any> = {};

function set<O>(key: string, val: O) {
    globalData[key] = val;
    return globalData;
}

function get<O>(key: string): O {
    return globalData[key];
}

export default {
    set,
    get,
};

